import { THEMES } from 'utils/config';

export interface MarkerProps {
  theme: string;
  x: string;
  y: string;
  content: {
    lineWidth: number;
  };
}

export const markers: MarkerProps[] = [
  {
    theme: THEMES.HOUSING,
    x: '18%',
    y: '19%',
    content: {
      lineWidth: 520,
    },
  },
  {
    theme: THEMES.FOOD,
    x: '20.5%',
    y: '19%',
    content: {
      lineWidth: 220,
    },
  },
  {
    theme: THEMES.ROADS,
    x: '36.5%',
    y: '55%',
    content: {
      lineWidth: 230,
    },
  },
  {
    theme: THEMES.FACTORIES,
    x: '39%',
    y: '35%',
    content: {
      lineWidth: 280,
    },
  },
  {
    theme: THEMES.WATER,
    x: '72.5%',
    y: '47%',
    content: {
      lineWidth: 320,
    },
  },
  {
    theme: THEMES.MILITARY,
    x: '56.5%',
    y: '65.5%',
    content: {
      lineWidth: 280,
    },
  },
];
